var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('router-link', {
    staticClass: "menu-item",
    class: {
      notActive: _vm.route.name === 'IndexPage' && _vm.$route.name != 'IndexPage'
    },
    attrs: {
      "to": {
        name: _vm.route.name,
        params: _vm.routeParams
      }
    }
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v(_vm._s(_vm.label))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }